var resize = $('#croppie-container').croppie({
    enableExif: true,
    enableOrientation: true,
    customClass: 'croppie-comfortable',
    viewport: {
        width: 1080,
        height: 1080,
        type: 'square'
    },
    boundary: {
        width: 1180,
        height: 1180
    }
});

$('#croppie-image-upload').on('change', function () {
    var reader = new FileReader();

    if (this.files[0]) {
        // toBase64($(this));
        reader.onload = function (e) {
            resize.croppie('bind', {
                url: e.target.result
            }).then(function () {
                console.log('jQuery bind complete');
            });
        }
        reader.readAsDataURL(this.files[0]);
    }
});

$('.fileinput-exists').on('click', function (ev) {
    resetAndRecreateCroppie()
});

function resetAndRecreateCroppie() {
    // Destruir a instância atual
    resize.croppie('destroy');

    // Limpar o input de arquivo, se aplicável
    $('#croppie-image-upload').val('');

    // Remover o contêiner anterior, se necessário
    $('#croppie-container').empty();

    // Criar uma nova instância Croppie no contêiner
    resize = $('#croppie-container').croppie({
        enableExif: true,
        enableOrientation: true,
        customClass: 'croppie-comfortable',
        viewport: {
            width: 1080,
            height: 1080,
            type: 'square'
        },
        boundary: {
            width: 1180,
            height: 1180
        }
    });
}

$('.croppie-btn-image').on('click', function (ev) {
    $("#modalCropImage").modal('hide');
    resize.croppie('result', {
        type: 'canvas',
        size: 'viewport'
    }).then(function (img) {
        html = '<img src="' + img + '" class="img-thumbnail croppie-thumbnail"/>';
        $("#preview-crop-image").html(html);
        let inputNameImg = $('.croppie-btn-image').data('target-input-img');

        toBase64To($('#croppie-image-upload'), img);
    });
});

function toBase64To(input, Base64) {
    const file = input[0].files[0];
    const fileReader = new FileReader();
    let inputNameImg = $('.croppie-btn-image').data('target-input-img');

    fileReader.onloadend = function () {
        let targetInput = $('.croppie-target-input-hidden');
        targetInput.append($("<input/>", {
            value: Base64,
            height: 100,
            name: 'inputNameImg[]',
            // type: 'hidden',
            default: false,
        }));
    };
    fileReader.readAsDataURL(file);
    // input.val('');
}